import _                                from 'underscore';
import { formatOption, IFormatOptions } from '../FormattingUtility';


export const generateStepwiseOptions = (
    min                     = 0,
    max                     = 10,
    step                    = 1,
    itemType                = 'Items',
    quantityModifierMap     = {}, // { 2: 'Items' }, // marker for when in the step process a modifier should be applied
    noneOptionLabel         = 'None',
    options: IFormatOptions = {}
) => {

    let nextModifier = itemType;

    return _.range( min, max, step ).map( ( item: number ) => {

            let hasModifier = _.chain( quantityModifierMap ).keys().map( key => parseInt( key ) ).contains( item ).value();

            if( hasModifier ){
                nextModifier = quantityModifierMap[ item ];
            }

            let label = ( item === 0 )
                        ? noneOptionLabel ? noneOptionLabel : `${ item } ${ nextModifier }`
                        : `${ item } ${ nextModifier }`;

            return formatOption( parseFloat( item as unknown as string ), label, options ?? {} );
        }
    );
};

export const cloneWithoutReference = ( originalObj: object ) => {

    // a very mean and dirty way to copy an object without reference...
    return JSON.parse( JSON.stringify( originalObj ) );
}
